<template>
  <article class="whoweare-wrapper">
    <div class="container">
      <p class="title">Who we are...</p>
    </div>
    <div class="con-wrapper">
      <div class="container inner">
        <div class="img-wrapper"></div>
        <div class="text-wrapper">
          <p>
            Outing<br />
            <span
              >Outing Program은 CARROTians들의 가치를 키워가는 글로벌 배낭여행
              행복 프로그램입니다.</span
            >
          </p>
          <a href="https://www.youtube.com/watch?v=qafT5yHglW0" target="_blank"
            >싱가포르로 떠난 1년 묵은 당근이들의 아웃팅 이야기!<br />
            함께 여행을 하며 목적지가 중요한 것이 아니라<br />
            함께하는 사람들이 중요하다것을 느낀 소중한 시간이였습니다!</a
          >
          <p>
            Dana & Emily & Daisy
            <a
              href="https://www.youtube.com/watch?v=qafT5yHglW0"
              target="_blank"
              >more</a
            >
          </p>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.whoweare-wrapper {
  padding: 40px 0px;

  .title {
    font-size: 40px;
    font-weight: bold;
    color: #3e3d4e;
    text-align: center;
  }

  .con-wrapper {
    background: url(~@/assets/img/newGlobal/main/whoweare/bg.png) repeat-x;
    background-position: -300px 160px;
    padding-bottom: 20px;

    .inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 56px 0;

      .img-wrapper {
        width: 300px;
        height: 300px;
        border-radius: 100%;
        overflow: hidden;
        background: url(~@/assets/img/newGlobal/main/whoweare/outing-bg.png)
          no-repeat center / cover;
      }

      .text-wrapper {
        p:nth-child(1) {
          font-size: 21px;
          font-weight: bold;
          color: #373731;
          margin-bottom: 30px;

          span {
            font-size: 15px;
            font-weight: normal;
          }
        }

        > a {
          font-size: 22px;
          color: #575757;
          margin-bottom: 15px;
        }

        p:nth-child(3) {
          font-size: 14px;
          color: #848484;

          a {
            display: inline-block;
            font-size: 13px;
            color: #232323;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .whoweare-wrapper {
    padding: 80px 0px;

    .title {
      font-size: 86px;
      text-align: right;
      position: relative;
      top: 30px;
    }

    .con-wrapper {
      background-position: 160px 0;
      padding: 40px 0;

      .inner {
        position: relative;
        flex-direction: row;
        gap: 0 56px;

        .img-wrapper {
          position: absolute;
          left: 0;
        }

        .text-wrapper {
          margin-left: 350px;

          p:nth-child(1) {
            font-size: 20px;
            margin-bottom: 30px;

            span {
              font-size: 14px;
              font-weight: normal;
              margin-left: 10px;
            }

            br {
              display: none;
            }
          }

          > a {
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>
